// Tags every real "add to cart" submission with the variant that was just added, via a hidden
// attributes[] field, so the cart drawer's complementary-products section can be based on an explicit
// "most recently added" signal rather than inferring it from cart.items array order (which broke
// whenever an add-on like the gift box or ocean top-up landed at the end of the array instead of the
// customer's actual product). Runs on the capture phase so the field is populated before product-form's
// own bubble-phase submit handler reads the form's FormData.
//
// sprout-topup-button (gift box, ocean top-up) posts to cart/add.js directly without a <form> submit
// event, so it never reaches this listener — exactly the behavior we want, since those adds shouldn't
// override the tracked product.
(function () {
  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.closest('product-form')) {
      return;
    }

    var variantField = form.elements['id'];

    if (!variantField || !variantField.value) {
      return;
    }

    var attributeField = form.querySelector('input[name="attributes[complementary_last_added_variant]"]');

    if (!attributeField) {
      attributeField = document.createElement('input');
      attributeField.type = 'hidden';
      attributeField.name = 'attributes[complementary_last_added_variant]';
      form.appendChild(attributeField);
    }

    attributeField.value = variantField.value;
  }, true);
})();
